module.exports = __webpack_public_path__ + "static/media/screenshot10.fde62636.png";